import {useSelector} from 'react-redux';
import {isEqual} from 'lodash'; // You can use any library for deep equality checking

const useDeepEqualSelector = (selector) => {
    return useSelector(selector, isEqual);
};

export default useDeepEqualSelector;
